module.exports = __webpack_public_path__ + "static/media/alien.844e4385.svg";